export enum EImageTypes {
  JPG = 'image/jpeg',
  PNG = 'image/png',
}

export enum EFileTypes {
  PDF = 'application/pdf',
}

export const CAllowedTypes = [EImageTypes.JPG, EImageTypes.PNG, EFileTypes.PDF];
export const CMaxMb = 5;
